export const Menus: MenuI = {
    clients: [
        {title: 'leads', module: 'clients', permission: 'VIEW_LEADS', route: 'leads', resource: 'SUB_MODULE_LEADS'},
        {title: 'company', module: 'clients', permission: 'VIEW_COMPANY', route: 'companies-list', resource: 'SUB_MODULE_COMPANY'},
        {title: 'contacts', module: 'clients', permission: 'VIEW_CONTACTS', route: 'contacts-list', resource: 'SUB_MODULE_CONTACT'}
    ],
    sales: [
        {title: 'deals', module: 'sales', permission: 'VIEW_DEALS', route: 'deals-list', resource: 'SUB_MODULE_DEALS' },
        {title: 'invoice', module: 'sales', permission: 'VIEW_INVOICE', route: 'invoice-list', resource: 'SUB_MODULE_INVOICE'},
        {title: 'sales order', module: 'sales', permission: 'VIEW_SALES_ORDER', route: 'sales-order-list', resource: 'SUB_MODULE_SALES_ORDER'},
        {title: 'quotation', module: 'sales', permission: 'VIEW_QUOTES', route: 'quotation-list', resource: 'SUB_MODULE_QUOTATION'},
        {title: 'subscriptions', module: 'sales', permission: 'VIEW_SUBSCRIPTIONS', route: 'Subscriptions-list', resource: 'SUB_MODULE_SUBSCRIPTION'},
        {title: 'proforma invoice', module: 'sales', permission: 'VIEW_PROFORMA_INVOICE', route: 'proforma-invoice-list', resource: 'SUB_MODULE_PROFORMA_INVOICE'},
        {title: 'receipt', module: 'sales', permission: 'VIEW_RECEIPT', route: 'receipt-list', resource: 'SUB_MODULE_RECEIPT'},
    ],
    target: [
        {title: 'period', module: 'target', permission: 'VIEW_PERIOD', route: 'period', resource: 'SUB_MODULE_PERIOD'},
        {title: 'company targets', module: 'target', permission: 'VIEW_COMPANY_TARGETS', route: 'targets', resource: 'SUB_MODULE_COMPANY_TARGETS'},
        {title: 'assigned targets', module: 'target', permission: 'VIEW_ASSIGNED_TARGETS', route: 'dashboard', resource: 'SUB_MODULE_ASSIGNED_TARGET'},
        {title: 'Commission Profiles', module: 'target', permission: 'VIEW_COMMISSION_PROFILES', route: 'commission-profiles', resource: 'SUB_MODULE_COMMISSION_PROFILES'},
        {title: 'Commissions', module: 'target', permission: 'VIEW_COMMISSION', route: 'commissions', resource: 'SUB_MODULE_COMMISSIONS'},
    ],
    ticket: [
        {title: 'Dashboard', module: 'ticket', permission: 'VIEW_DASHBOARD', route: 'ticket-dashboard', resource: 'SUB_MODULE_TICKETS_DASHBOARD'},
        {title: 'All Tickets', module: 'ticket', permission: 'VIEW_ALL_TICKET', route: 'all-ticket', resource: 'SUB_MODULE_ALL_TICKETS'},
        {title: 'ticket reports', module: 'ticket', permission: 'VIEW_TICKETS_REPORTS', route: 'ticket-reports', resource: 'SUB_MODULE_TICKETS_REPORTS'},
        {title: 'Agents', module: 'ticket', permission: 'VIEW_AGENTS', route: 'ticket-agents', resource: 'SUB_MODULE_TICKET_AGENTS'},
        {title: 'Groups', module: 'ticket', permission: 'VIEW_GROUPS', route: 'ticket-groups', resource: 'SUB_MODULE_TICKET_GROUPS'},
        {title: 'Calls', module: 'ticket', permission: 'VIEW_CALLS', route: 'ticket-calls', resource: 'SUB_MODULE_TICKET_CALLS'},
    ], 
    teams: [ 
        {title: 'sales person', module: 'teams', permission: 'VIEW_SALESPERSONS', route: 'saleperson-list', resource: 'SUB_MODULE_SALESPERSON'},
        {title: 'teams', module: 'teams', permission: 'VIEW_TEAMS', route: 'teams-list', resource: 'SUB_MODULE_TEAMS'},
    ]
}

interface MenuI {
    'clients': SubmenuI[],
    'sales': SubmenuI[],
    'target': SubmenuI[],
    'ticket': SubmenuI[],
    'teams': SubmenuI[]
}
export interface SubmenuI {
    title: string, 
    module: string, 
    permission: string, 
    route?: string,
    resource?: string
}
